import { createFileRoute, redirect } from '@tanstack/react-router';
import { PermissionSetEditPage } from '@/app/(client)/company-settings/-components/permissionSets/PermissionSetEditPage';
import { ensurePermissions } from '@/hooks/usePermissions';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/permission-sets/$setKey/edit',
)({
  // Withholding the Edit action is not access control: this URL can be typed,
  // and without the guard someone reworks a whole grid and only learns at Save
  // that `PATCH /roles/:key` answers 403. Sent to the set's read-only view
  // rather than away from it — they may still look.
  beforeLoad: async ({ params }) => {
    const perms = await ensurePermissions();
    if (!perms['permission-access'].canEdit) {
      throw redirect({
        to: '/company-settings/permission-sets/$setKey',
        params: { setKey: params.setKey },
      });
    }
  },
  component: EditPermissionSetRoute,
});

/** Editing is one page, not the create wizard. `PermissionSetBuilderPage` still
 *  serves `/new`, where the five steps earn their keep because nothing exists
 *  yet; an existing set has nothing to sequence. */
function EditPermissionSetRoute() {
  const { setKey } = Route.useParams();
  const companyId = useSessionStore(s => s.user?.companyId);
  if (!companyId) return null;
  return <PermissionSetEditPage companyId={companyId} setKey={setKey} />;
}
